import React, { useEffect, useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { IConstants, ISession } from '../../../models/pro-sites';
import TextInput from '../../inputs/text-input';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';
import './schedule-pickup.css';
import {
    IUPSPickupRequest,
    PickupRequestDTO,
    UPSPickupRequestErrors,
} from '../../../models/ups-pickup-request';
import { matchesNameCode } from '../../../common';
import { loadConstants } from '../../../store/externals/externals-actions';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { FieldValidation, validate } from '../../../validation/validation';
import * as Validators from '../../../validation/validators';
import { IProfile } from '../../../models/profile';
import { loadProfile } from '../../../store/profile/profile-actions';
import { loadSession } from '../../../store/session/session-actions';
import { loadSessionAccount } from '../../../store/account/account-actions';
import { IAccount } from '../../../models/company-account';
import SelectInput from '../../inputs/select-input';
import { submitUpsPickupRequest } from '../../../api/schedule-pickup-api';
import { IResult } from '../../../models/result-models';
import Popover, { createPopover } from '../../common/popover';
import ScheduleUPSPickupThankYou from './schedule-pickup-thankyou';
import moment from 'moment';
interface IScheduleUPSPickupProps {
    session: ISession | null;
    constants: IConstants | null;
    loadConstants: () => Promise<void>;
    upsPickupRequest: IUPSPickupRequest;
    profile: IProfile | null;
    loadProfile: () => Promise<void>;
    loadSession: () => Promise<void>;
    sessionAccount: IAccount | null;
    loadSessionAccount: () => Promise<void>;
}

export const ScheduleUPSPickup = ({
    session,
    constants,
    profile,
    sessionAccount,
    upsPickupRequest,
    loadConstants,
    loadProfile,
    loadSession,
    loadSessionAccount,
}: IScheduleUPSPickupProps) => {
    const intl = useIntl();
    const [errorsState, setErrorsState] = useState<UPSPickupRequestErrors>({});
    const [upsPickupRequestState, setUpsPickupRequestState] = useState({
        ...upsPickupRequest!,
    });
    const [saving, setSaving] = useState(false);
    const [validating, setValidating] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const errors: string[] = [];
    const [upsPickupServiceErrors, setUpsPickupServiceErrors] =
        useState(errors);
    const [fieldsInitialized, setFieldsInitialized] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const unspecifiedError: any =
        'An unspecified error occurred submitting Scheduled UPS Pickup Request.';
    const isNuEar = window.location.href.includes('nuearpro');

    const roundedNow = () => {
        const now = moment();
        return now.add(5 - (now.minute() % 5), 'minutes');
    };

    const setEndOfDay = (date: Date) => {
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            23,
            55
        );
    };

    const initialDateTime = roundedNow().toDate();
    const initialDateTimePlus2Hours = new Date(
        initialDateTime.getFullYear(),
        initialDateTime.getMonth(),
        initialDateTime.getDate(),
        initialDateTime.getHours() + 2,
        initialDateTime.getMinutes()
    );

    const [minTimeMin, setMinTimeMin] = useState(initialDateTime);
    const [minTimeMax, setMinTimeMax] = useState(setEndOfDay(initialDateTime));
    const [maxTimeMin, setMaxTimeMin] = useState(minTimeMin);
    const [maxTimeMax, setMaxTimeMax] = useState(minTimeMax);

    const setMinMaxTimes = (date: Date) => {
        const today = new Date();
        if (
            date!.getFullYear() === today.getFullYear() &&
            date!.getDate() === today.getDate()
        ) {
            setMinTimeMin(initialDateTime);
            setMinTimeMax(setEndOfDay(initialDateTime));
            setMaxTimeMin(date);
            setMaxTimeMax(setEndOfDay(date));
        } else {
            setMinTimeMin(
                new Date(date!.getFullYear(), date!.getMonth(), date!.getDate())
            );
            setMinTimeMax(setEndOfDay(minTimeMin));
            setMaxTimeMin(minTimeMin);
            setMaxTimeMax(setEndOfDay(minTimeMin));
        }
    };

    const shipLabelLink = (
        <a href={'/prosite/my-account/online-forms/shipping-labels'}>
            <FormattedMessage
                id="Printable_UPS_Label"
                defaultMessage="Printable UPS Label"
            />
        </a>
    );

    useEffect(() => {
        if (
            upsPickupRequestState!.street2! !== undefined &&
            upsPickupRequestState!.street2! !== null &&
            upsPickupRequestState.street2.length === 0
        ) {
            const request = update(upsPickupRequestState, {
                street2: {
                    $set: null,
                },
            });
            setUpsPickupRequestState(request);
        }
    }, [upsPickupRequestState.street2]);

    useEffect(() => {
        if (
            upsPickupRequestState!.pickupMinTime! >
            upsPickupRequestState!.pickupMaxTime!
        ) {
            const request = update(upsPickupRequestState, {
                pickupMaxTime: {
                    $set: upsPickupRequestState!.pickupMinTime!,
                },
            });
            setUpsPickupRequestState(request);
        }
    }, [upsPickupRequestState.pickupMinTime]);

    useEffect(() => {
        if (
            upsPickupRequestState!.pickupMinTime! >
            upsPickupRequestState!.pickupMaxTime!
        ) {
            const request = update(upsPickupRequestState, {
                pickupMinTime: {
                    $set: upsPickupRequestState!.pickupMaxTime!,
                },
            });
            setUpsPickupRequestState(request);
        }
    }, [upsPickupRequestState.pickupMaxTime]);

    useEffect(() => {
        if (validating) {
            formIsValid();
        }
    }, [upsPickupRequestState]);

    useEffect(() => {
        if (!constants) {
            loadConstants();
        }
    });

    useEffect(() => {
        if (!profile) {
            loadProfile();
        }
    });

    useEffect(() => {
        if (!sessionAccount) {
            loadSessionAccount();
        }
    });

    useEffect(() => {
        if (!fieldsInitialized && profile && session && sessionAccount) {
            setFieldsInitialized(true);
            setSaving(false);
            setFormSubmitted(false);
            setValidating(false);
            createPopover();
            console.log({
                object: 'profile on initialize',
                contents: profile,
            });
            console.log({
                object: 'sessionAccount on initialize',
                contents: sessionAccount,
            });
            setUpsPickupRequestState({
                contactName: (
                    profile!.firstName +
                    ' ' +
                    profile!.lastName
                ).substr(0, 21),
                businessName: sessionAccount!.partyName
                    ? sessionAccount!.partyName.substring(0, 27)
                    : '',
                phoneNumber: session!.contactInfo!.phone,
                street1: sessionAccount!.street1,
                street2: sessionAccount!.street2,
                city: sessionAccount!.city,
                state: sessionAccount!.state,
                zipCode: sessionAccount!.postalCode
                    ? sessionAccount!.postalCode.substring(0, 5)
                    : '',
                pickupDate: initialDateTime,
                pickupMinTime: initialDateTime,
                pickupMaxTime: initialDateTimePlus2Hours,
                packageCount: 1,
                specialInstructions: '',
                prn: '',
            });
        }
    });

    const onCloseModal = () => {
        setSaving(false);
        setFormSubmitted(false);
        setUpsPickupRequestState((prevState) => ({
            ...prevState!,
            pickupDate: initialDateTime,
            pickupMinTime: initialDateTime,
            pickupMaxTime: initialDateTimePlus2Hours,
            packageCount: 1,
            specialInstructions: '',
            prn: '',
        }));
    };

    const onChangeDate = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        const request = update(upsPickupRequestState, {
            pickupDate: {
                $set: _date,
            },
        });
        setUpsPickupRequestState(request);
        setMinMaxTimes(_date!);
    };

    const onChangePickupMinTime = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        const request = update(upsPickupRequestState, {
            pickupMinTime: {
                $set: _date,
            },
        });
        setUpsPickupRequestState(request);
    };

    const onChangePickupMaxTime = (
        _date: Date | null,
        event: React.SyntheticEvent<any, Event> | undefined
    ) => {
        const request = update(upsPickupRequestState, {
            pickupMaxTime: {
                $set: _date,
            },
        });
        setUpsPickupRequestState(request);
    };

    const onChange = (event: any) => {
        const { name, value } = event.target;
        if (event.target!.name === 'packageCount') {
            if (isNaN(value) || value.toString().contains(' ')) {
                return;
            }
        }

        const request = update(upsPickupRequestState, {
            [name]: { $set: value },
        });
        setUpsPickupRequestState(request);
    };
    useEffect(() => {
        if (!errorsState) return;
        console.log(errorsState);
    }, [errorsState]);
    const fieldValidations = [
        new FieldValidation('pickupDate', 'Date', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Date',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('pickupMinTime', 'Earliest Pickup Time', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Earliest_Pickup_Time',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('pickupMaxTime', 'Latest Pickup Time', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Latest_Pickup_Time',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('packageCount', 'Package(s) in your Pickup', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Package(s)_in_Your_Pickup',
                            defaultMessage: 'Package(s) in your Pickup',
                        }),
                    }
                )
            ),
            Validators.maxQuantity(30),
            Validators.minQuantity(1),
        ]),
        new FieldValidation('businessName', 'Business Name', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Business_Name',
                            defaultMessage: 'Business Name',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('contactName', 'Contact Name', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Contact_Name' }),
                    }
                )
            ),
        ]),
        new FieldValidation('phoneNumber', 'Phone Number', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Phone_Number',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('street1', 'Address Line 1', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Address_Line_1',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('city', 'City', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'City',
                        }),
                    }
                )
            ),
        ]),
        new FieldValidation('zipCode', 'Postal Code', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({
                            id: 'Postal_Code',
                        }),
                    }
                )
            ),
        ]),
    ];

    const formIsValid = (): boolean => {
        const errors: UPSPickupRequestErrors = validate(
            upsPickupRequestState,
            fieldValidations
        );

        setErrorsState(errors);

        return Object.keys(errors).length === 0;
    };

    const formInvalid = () => {
        const errorLength = Object.keys(errorsState).length;
        return errorLength > 0 && !(errorLength === 1 && saveError);
    };

    const save = async () => {
        try {
            setSaving(true);

            const dto: PickupRequestDTO = {
                ContactName: upsPickupRequestState!.contactName,
                BusinessName: upsPickupRequestState!.businessName,
                PhoneNumber: upsPickupRequestState!.phoneNumber,
                Street1: upsPickupRequestState!.street1,
                Street2: upsPickupRequestState!.street2!,
                City: upsPickupRequestState!.city,
                State: upsPickupRequestState!.state,
                ZipCode: upsPickupRequestState!.zipCode,
                PickupDate: upsPickupRequestState.pickupDate
                    ? upsPickupRequestState.pickupDate
                          .toLocaleDateString()
                          .replace(/[^ -~]/g, '') // IE 11 toLocaleDateString returns ANSI; clean it so UPS API does not fail
                    : '',
                PickupMinTime: upsPickupRequestState.pickupMinTime
                    ? upsPickupRequestState.pickupMinTime
                          .toLocaleTimeString()
                          .replace(/[^ -~]/g, '')
                    : '',
                PickupMaxTime: upsPickupRequestState.pickupMaxTime
                    ? upsPickupRequestState.pickupMaxTime
                          .toLocaleTimeString()
                          .replace(/[^ -~]/g, '')
                    : '',
                PackageCount: upsPickupRequestState.packageCount!.toString(),
                SpecialInstructions: upsPickupRequestState.specialInstructions,
            };

            console.log({
                object: 'dto in handleSave!!',
                contents: dto,
            });

            const result: IResult<string> = await submitUpsPickupRequest(dto);
            if (result!.ok && result!.data! && !result!.errors) {
                setSaving(false);

                const responsebody = JSON.parse(
                    JSON.parse(JSON.stringify(result.data)).Body!
                );

                if (responsebody!.ErrorDetail!) {
                    const errs = new Set<string>();
                    responsebody!.ErrorDetail!.forEach(
                        (item: { PrimaryErrorCode: any }) =>
                            errs.add(item.PrimaryErrorCode!.Description!)
                    );
                    setUpsPickupServiceErrors(Array.from(errs));
                    setSaveError(true);
                    return;
                }

                setValidating(false);

                const request = update(upsPickupRequestState, {
                    prn: {
                        $set: responsebody!.PRN!,
                    },
                });
                setUpsPickupRequestState(request);

                setFormSubmitted(true);
            } else {
                setSaving(false);
                if (result!.errors) {
                    setUpsPickupServiceErrors(result.errors);
                } else {
                    setSaveError(unspecifiedError);
                }
            }
        } catch (error) {
            setSaving(false);
            setSaveError(true);
        }
    };

    const handleSave = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        setValidating(true);
        setUpsPickupServiceErrors([]);
        setSaveError(false);
        console.log({
            object: 'upsPickupRequestState in handleSave',
            contents: upsPickupRequestState,
        });
        if (!formIsValid()) {
            return;
        }

        save();
    };

    return (
        <>
            {session && constants && (
                <>
                    <form onSubmit={handleSave}>
                        <div className="row">
                            {!formSubmitted && (
                                <div className="col-sm-9">
                                    <h1
                                        className={
                                            isNuEar ? 'nuEar' : 'starkey'
                                        }
                                    >
                                        <FormattedMessage
                                            id="Schedule_UPS_Pickup"
                                            defaultMessage="Schedule UPS Pickup"
                                        />
                                    </h1>
                                    <div className="well">
                                        <div
                                            className="form-horizontal"
                                            role="form"
                                        >
                                            <h3
                                                className={
                                                    isNuEar
                                                        ? 'gutter-top underline forms nuear'
                                                        : 'gutter-top underline forms starkey'
                                                }
                                            >
                                                <FormattedMessage
                                                    id="Pickup_Information"
                                                    defaultMessage="Pickup Information"
                                                />
                                            </h3>
                                            <div
                                                className={
                                                    !upsPickupRequestState.pickupDate &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <label
                                                    className="control-label col-sm-4"
                                                    htmlFor="pickupDate"
                                                >
                                                    <FormattedMessage
                                                        id="Date"
                                                        defaultMessage="Date"
                                                    />
                                                    :
                                                </label>
                                                <div className="col-sm-8 col-md-4">
                                                    <div className="input-group">
                                                        <div className="input-group-addon">
                                                            <span className="glyphicon glyphicon-calendar"></span>
                                                        </div>
                                                        <DatePicker
                                                            className={
                                                                !upsPickupRequestState.pickupDate &&
                                                                validating
                                                                    ? 'date-picker-ups-has-error'
                                                                    : 'date-picker-ups'
                                                            }
                                                            selected={
                                                                upsPickupRequestState.pickupDate
                                                            }
                                                            selectsStart={true}
                                                            name="pickupDate"
                                                            onChange={
                                                                onChangeDate
                                                            }
                                                            autoComplete="off"
                                                            isClearable={false}
                                                            showTimeSelect={
                                                                false
                                                            }
                                                            popperPlacement="right"
                                                            minDate={
                                                                initialDateTime
                                                            }
                                                            maxDate={
                                                                new Date(
                                                                    9999,
                                                                    12,
                                                                    31
                                                                )
                                                            }
                                                        />
                                                        <span
                                                            className={
                                                                !upsPickupRequestState.pickupDate &&
                                                                validating
                                                                    ? 'input-group-addon input-group-addon-ups-haserror'
                                                                    : 'input-group-addon input-group-addon-ups'
                                                            }
                                                        >
                                                            *
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.pickupMinTime &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <label className="control-label col-sm-4">
                                                    <FormattedMessage
                                                        id="Earliest_Pickup_Time"
                                                        defaultMessage="Earliest Pickup Time"
                                                    />
                                                    :
                                                    <Popover
                                                        content={intl.formatMessage(
                                                            {
                                                                id: 'Select_Earliest_Pickup_Time',
                                                                defaultMessage:
                                                                    'Select the earliest time that your shipment will be ready for pickup',
                                                            }
                                                        )}
                                                    />
                                                </label>
                                                <div className="col-sm-8 col-md-4">
                                                    <div className="input-group">
                                                        <div className="input-group-addon">
                                                            <span className="glyphicon glyphicon-time"></span>
                                                        </div>
                                                        <DatePicker
                                                            className={
                                                                !upsPickupRequestState.pickupMinTime &&
                                                                validating
                                                                    ? 'date-picker-ups-has-error'
                                                                    : 'date-picker-ups'
                                                            }
                                                            selected={
                                                                upsPickupRequestState.pickupMinTime
                                                            }
                                                            name="pickupMinTime"
                                                            onChange={
                                                                onChangePickupMinTime
                                                            }
                                                            dateFormat={
                                                                'h:mm aa'
                                                            }
                                                            showTimeSelect={
                                                                true
                                                            }
                                                            showTimeSelectOnly={
                                                                true
                                                            }
                                                            minTime={minTimeMin}
                                                            maxTime={minTimeMax}
                                                            timeIntervals={5}
                                                            popperPlacement="right"
                                                        />
                                                        <span
                                                            className={
                                                                !upsPickupRequestState.pickupMinTime &&
                                                                validating
                                                                    ? 'input-group-addon input-group-addon-ups-haserror'
                                                                    : 'input-group-addon input-group-addon-ups'
                                                            }
                                                        >
                                                            *
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.pickupMaxTime &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <label
                                                    className="control-label col-sm-4"
                                                    htmlFor="pickupMaxTime"
                                                >
                                                    <FormattedMessage
                                                        id="Latest_Pickup_Time"
                                                        defaultMessage="Latest Pickup Time:"
                                                    />
                                                    :
                                                    <Popover
                                                        content={intl.formatMessage(
                                                            {
                                                                id: 'Select_Latest_Pickup_Time',
                                                                defaultMessage:
                                                                    'Select the latest time at which UPS will be able to gain access to your shipment',
                                                            }
                                                        )}
                                                    />
                                                </label>
                                                <div className="col-sm-8 col-md-4">
                                                    <div className="input-group">
                                                        <div className="input-group-addon">
                                                            <span className="glyphicon glyphicon-time"></span>
                                                        </div>
                                                        <DatePicker
                                                            className={
                                                                !upsPickupRequestState.pickupMaxTime &&
                                                                validating
                                                                    ? 'date-picker-ups-has-error'
                                                                    : 'date-picker-ups'
                                                            }
                                                            selected={
                                                                upsPickupRequestState.pickupMaxTime
                                                            }
                                                            name="pickupMaxTime"
                                                            onChange={
                                                                onChangePickupMaxTime
                                                            }
                                                            dateFormat={
                                                                'h:mm aa'
                                                            }
                                                            showTimeSelect={
                                                                true
                                                            }
                                                            showTimeSelectOnly={
                                                                true
                                                            }
                                                            minTime={maxTimeMin}
                                                            maxTime={maxTimeMax}
                                                            timeIntervals={5}
                                                            popperPlacement="right"
                                                        />
                                                        <span
                                                            className={
                                                                !upsPickupRequestState.pickupMaxTime &&
                                                                validating
                                                                    ? 'input-group-addon input-group-addon-ups-haserror'
                                                                    : 'input-group-addon input-group-addon-ups'
                                                            }
                                                        >
                                                            *
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <TextInput
                                                    name="packageCount"
                                                    label={
                                                        'Package(s) in your Pickup'
                                                    }
                                                    labelClassName="control-label-ups col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState.packageCount
                                                    }
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        errorsState.packageCount
                                                    }
                                                    showError={true}
                                                />
                                                <div
                                                    className="col-sm-offset-4 col-sm-8 col-md-6 has-error"
                                                    hidden={
                                                        !validating ||
                                                        (parseInt(
                                                            upsPickupRequestState.packageCount.toString()
                                                        ) > 0 &&
                                                            parseInt(
                                                                upsPickupRequestState.packageCount.toString()
                                                            ) < 31)
                                                    }
                                                >
                                                    <span className="control-label">
                                                        <FormattedMessage
                                                            id="Number_Of_Packages_Range"
                                                            defaultMessage="The number of packages for pickup must be between 1 and 30."
                                                        />
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label className="control-label col-sm-4">
                                                    <span>
                                                        <FormattedMessage
                                                            id="Special_Instructions_UPS"
                                                            defaultMessage="Special Instructions for UPS Driver"
                                                        />
                                                        :
                                                    </span>
                                                </label>
                                                <div className="col-sm-8 col-md-6">
                                                    <textarea
                                                        className="form-control"
                                                        name="specialInstructions"
                                                        value={
                                                            upsPickupRequestState.specialInstructions
                                                        }
                                                        onChange={onChange}
                                                        required={false}
                                                        maxLength={57}
                                                    />
                                                    <span className="pull-right">
                                                        {57 -
                                                            (upsPickupRequestState.specialInstructions
                                                                ? upsPickupRequestState
                                                                      .specialInstructions
                                                                      .length
                                                                : 0)}
                                                    </span>
                                                </div>
                                            </div>

                                            <h3
                                                className={
                                                    isNuEar
                                                        ? 'gutter-top underline forms nuear'
                                                        : 'gutter-top underline forms starkey'
                                                }
                                            >
                                                <FormattedMessage
                                                    id="Pick_Up_Location"
                                                    defaultMessage="Pick Up Location"
                                                />
                                            </h3>
                                            <div className={'form-group'}>
                                                <TextInput
                                                    name="contactName"
                                                    label="Contact Name"
                                                    labelClassName="control-label-ups col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState!
                                                            .contactName!
                                                    }
                                                    maxLength={22}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        errorsState.contactName
                                                    }
                                                    showError={true}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.businessName &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <TextInput
                                                    name="businessName"
                                                    label="Business Name"
                                                    labelClassName="control-label-ups col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState!
                                                            .businessName!
                                                    }
                                                    maxLength={27}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        errorsState.businessName
                                                    }
                                                    showError={true}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.phoneNumber &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <TextInput
                                                    name="phoneNumber"
                                                    label="Phone Number"
                                                    labelClassName="ontrol-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState!
                                                            .phoneNumber!
                                                    }
                                                    maxLength={20}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={
                                                        errorsState.phoneNumber
                                                    }
                                                    showError={true}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.street1 &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <TextInput
                                                    name="street1"
                                                    label="Address Line 1"
                                                    labelClassName="control-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState!
                                                            .street1!
                                                    }
                                                    maxLength={30}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={errorsState.street1}
                                                    showError={true}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <TextInput
                                                    name="street2"
                                                    label="Address Line 2"
                                                    labelClassName="control-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState!
                                                            .street2!
                                                    }
                                                    maxLength={30}
                                                    onChange={onChange}
                                                    required={false}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.city &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <TextInput
                                                    name="city"
                                                    label="City"
                                                    labelClassName="control-label col-sm-4"
                                                    fieldClassName="col-sm-8 col-md-6"
                                                    value={
                                                        upsPickupRequestState!
                                                            .city!
                                                    }
                                                    maxLength={30}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={errorsState.city}
                                                    showError={true}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.state &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <SelectInput
                                                    name="state"
                                                    label="State"
                                                    labelClassName="control-label col-sm-4"
                                                    fieldClassName="col-sm-4"
                                                    options={constants.states.map(
                                                        (st) => ({
                                                            value: st.code,
                                                            text: st.name,
                                                        })
                                                    )}
                                                    value={
                                                        upsPickupRequestState!
                                                            .state!
                                                    }
                                                    hasDefaultOption={false}
                                                    onChange={onChange}
                                                    required={false}
                                                />
                                            </div>

                                            <div
                                                className={
                                                    !upsPickupRequestState.zipCode &&
                                                    validating
                                                        ? 'form-group has-error'
                                                        : 'form-group'
                                                }
                                            >
                                                <TextInput
                                                    name="zipCode"
                                                    label="Postal Code"
                                                    labelClassName="control-label col-sm-4"
                                                    fieldClassName="col-sm-4"
                                                    value={
                                                        upsPickupRequestState!
                                                            .zipCode!
                                                    }
                                                    maxLength={5}
                                                    onChange={onChange}
                                                    required={true}
                                                    error={errorsState.zipCode}
                                                    showError={true}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label className="control-label-ups col-sm-4">
                                                    <FormattedMessage
                                                        id="Country"
                                                        defaultMessage="Country"
                                                    />
                                                    :
                                                </label>
                                                <div className="col-sm-8">
                                                    <p className="form-control-static">
                                                        USA
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <h3
                                            className={
                                                isNuEar
                                                    ? 'gutter-top underline forms nuear'
                                                    : 'gutter-top underline forms starkey'
                                            }
                                        >
                                            <FormattedMessage
                                                id="Important_Note"
                                                defaultMessage="Important Note"
                                            />
                                            :
                                        </h3>
                                        <p>
                                            In order for the UPS driver to
                                            complete a package pickup, you must
                                            include a UPS Shipping Label. Please
                                            visit the {shipLabelLink} page to
                                            generate a shipping label.
                                        </p>
                                    </div>
                                    {formInvalid() && (
                                        <div className="alert alert-danger">
                                            <span>
                                                <FormattedMessage
                                                    id="Please_enter_into_before_submitting"
                                                    defaultMessage="Please enter all required information before submitting"
                                                />
                                            </span>
                                        </div>
                                    )}
                                    {saveError && (
                                        <div className="alert alert-danger">
                                            <strong>
                                                UPS pickup scheduling service
                                                reported the following error(s):
                                            </strong>
                                            <ul className="list">
                                                {upsPickupServiceErrors.map(
                                                    (item) => (
                                                        <li key="{shortid.generate}">
                                                            {item}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    )}
                                    <div className="gutter-top">
                                        <button
                                            id="save-changes"
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            <span>
                                                {saving ? (
                                                    <>
                                                        {
                                                            'Submitting Request ...'
                                                        }
                                                    </>
                                                ) : (
                                                    <>
                                                        {
                                                            'Submit Pickup Request'
                                                        }
                                                    </>
                                                )}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {formSubmitted && (
                                <ScheduleUPSPickupThankYou
                                    upsPickupRequest={upsPickupRequestState}
                                    onAccept={() => undefined}
                                    onClose={onCloseModal}
                                    isNuEar={isNuEar}
                                />
                            )}
                        </div>
                    </form>
                </>
            )}
        </>
    );
};

const mapProfileFromState = (
    profile: IProfile | null,
    session: ISession | null,
    constants: IConstants | null
): IProfile | null => {
    if (!profile || !session || !constants) {
        return profile!;
    }

    const value = profile.country || session.country;
    const found = constants.countries.find(matchesNameCode(value));

    return found && profile.country === found.code
        ? profile
        : { ...profile, country: found ? found.code : undefined };
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
        constants: state.constants,
        profile: mapProfileFromState(
            state.profile ? state.profile.data! : null,
            state.session ? state.session.data! : null,
            state.constants
        ),
        sessionAccount: state.sessionAccount
            ? state.sessionAccount!.data!
            : null,
    };
};

const mapDispatchToProps = {
    loadConstants,
    loadProfile,
    loadSession,
    loadSessionAccount,
};

const scheduleUPSPickupContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(React.memo(ScheduleUPSPickup));

export default scheduleUPSPickupContainer;
